import WidgetConfigMenu from '../widget-config-menu'

const ImageConfig = WidgetConfigMenu.extend({

	/** @type {ImageWidget} */
	model: null,

	typeSpecificTargets: function (hasTemplate) {
		return [
			this.uploadNewImage(),
			this.chooseSharedImage()
		]
	},

	uploadNewImage: function () {
		return {
			type: 'dialog',
			label: 'dashboards.image.pick.new',
			target: (e) => {
				e.preventDefault()
				e.stopPropagation()

				this.getWidgetView().fileSelector.upload()
			}
		}
	},

	chooseSharedImage: function () {
		return {
			type: 'dialog',
			label: 'dashboards.image.pick.shared.choose',
			target: (e) => {
				e.preventDefault()
				e.stopPropagation()

				this.getWidgetView().fileSelector.addSharedImage()
			}
		}
	},

	/**
	 * @return {ImageView}
	 */
	getWidgetView: function () {
		return this.options.widgetUpdater
			.widgetViewsByModelCid()[this.model.cid]
	}

})

export default ImageConfig

ImageConfig.__filename__ = 'dashboards/widgets/image/image-config.js'
